import { render, staticRenderFns } from "./e-responsive-preview.vue?vue&type=template&id=4f84b8a0&scoped=true"
import script from "./e-responsive-preview.vue?vue&type=script&lang=js"
export * from "./e-responsive-preview.vue?vue&type=script&lang=js"
import style0 from "./e-responsive-preview.vue?vue&type=style&index=0&id=4f84b8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84b8a0",
  null
  
)

export default component.exports